import { z } from 'zod'

export const CountryStateZ = z.strictObject({
	code: z.string(),
	name: z.string(),
})

export type CountryState = z.infer<typeof CountryStateZ>

export const BCDCityZ = z.strictObject({
	code: z.string(),
	label: z.string(),
	location_type: z.string(),
	latitude: z.number(),
	longitude: z.number(),
	country_name: z.string(),
	country_iso: z.string(),
	city_name: z.string(),
})

export type BCDCity = z.infer<typeof BCDCityZ>
